import React, { useEffect, useState } from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import axiosUmbraco from '../axios/axiosUmbraco';
import { formatDate } from '../helper/formatDate';
import { Link } from 'react-router-dom';
import { useTranslate } from './TranslationText';
import { getNews } from './NewsComponents/api/newsApi';
const BaseURL = process.env.REACT_APP_BACKEND_API;
const pageId = process.env.REACT_APP_NEWS_ID;
const BaseReact = process.env.REACT_APP_BASE_URL;


export default function NewsSection() {

    const { translate } = useTranslate();
    const carouselOption = {
        loop: true,
        margin: 10,
        dotsEach: false,
        dots: false,
        nav: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 2.5
            }
        }
    }

    const [newsItems, setNewsItems] = useState([]);
    useEffect(() => {
        getNews().then(res => {
            setNewsItems(res);
        });
    }, [])


    return (
        newsItems.length > 0 &&
        <div className="secondSectionContainer mediaGalleryTitle mt-3">
            <div id="news" className="seasonSectionTitle mediaGalleryTitle">
                <span className="roboto-light">{translate('web.news', 'News')}</span>
            </div>
            <OwlCarousel className='owl-theme' {...carouselOption} dir='ltr'>
                {newsItems.map((item) => (
                    <Link to={!!item.link ? item.link : `${BaseReact}/singlePost?id=${item.id}`} target={!!item.link ? '_blank' : '_self'} className="item pointer" >
                        <div className="newsCard">
                            {item.image &&
                                <div className="newsImageContainer">
                                    {item.image &&
                                        <img src={BaseURL + item.image} alt="ChangeMe" onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = `${BaseReact}/img/whiteFlag.png`;
                                            e.target.style.display = 'none'
                                        }} />
                                    }
                                </div>
                            }
                            <div className="newsPost" style={item.image ? {} : { width: '100%', justifyContent: 'flex-start' }}>
                                {item.name &&
                                    <div className="newsPostTitle roboto-bold">
                                        {item.name}
                                    </div>
                                }
                                {item.description &&
                                    <div className="newsPostDesc roboto-regular">
                                        {item.description}
                                    </div>
                                }
                                {item.date &&
                                    <div className="newsPostDate roboto-bold">
                                        <i className="fa fa-calendar iconRed"></i> <span className="newsDate">
                                            {formatDate(item.date)}
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>
                    </Link>
                ))}
            </OwlCarousel>
        </div>
    )
}
